const license = {
    not_installed: 'このインスタンスにはライセンスがインストールされていません。',
    invalid_key: 'ライセンスキーが無効か、改ざんされています。',
    expired_key: 'ライセンスキーの有効期限が切れています。新しいキーを取得して再インストールしてください。',
};
export default Object.freeze(license);
